module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_search_gray-79cf2deaf714db369ccabede2000005e.svg";